import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";

function TableHeader(columns) {
  return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map(function (col) {
    return /*#__PURE__*/React.createElement("th", null, col);
  })));
}

export function TableView(_ref) {
  var data = _ref.data,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      className = _ref.className,
      hasHeader = _ref.hasHeader;
  return /*#__PURE__*/React.createElement("table", {
    className: className
  }, hasHeader && TableHeader(columns), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row) {
    return /*#__PURE__*/React.createElement("tr", null, row.map(function (item) {
      return /*#__PURE__*/React.createElement("td", null, item);
    }));
  })));
}
export var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = /*#__PURE__*/_createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);
    _this.state = {
      tableData: []
    };
    return _this;
  }

  _createClass(Table, [{
    key: "parseCSVToJson",
    value: function parseCSVToJson(content) {
      var _this2 = this;

      import(
      /* webpackChunkName: "qtc-parsecsv" */
      "papaparse").then(function (_ref2) {
        var parse = _ref2.parse;
        parse(content, {
          header: false,
          complete: function complete(results) {
            return _this2._isMounted && _this2.setState({
              tableData: results.data
            });
          } // with header true, the order of columns in table is not guaranteed by papaparse library, so we will parse including the header as table data and handle it after.

        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.parseCSVToJson(this.props.data.content);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.data.content !== nextProps.data.content) {
        this.parseCSVToJson(nextProps.data.content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.tableData.length > 0) {
        return null;
      }

      var _ref3 = this.props.hasHeader ? [this.state.tableData[0], this.state.tableData.slice(1)] : [[], this.state.tableData],
          _ref4 = _slicedToArray(_ref3, 2),
          columns = _ref4[0],
          tableData = _ref4[1];

      var className = "story-element-table-".concat(this.props.id);
      return /*#__PURE__*/React.createElement(this.props.tableComponent || TableView, {
        hasHeader: this.props.hasHeader,
        data: tableData,
        columns: columns,
        showPageSizeOptions: false,
        showPageJump: false,
        className: className
      });
    }
  }]);

  return Table;
}(React.Component);